import React from 'react';
import { render } from 'react-dom';
import { createStore, compose } from 'redux';
import { connect } from 'react-redux';
import { install } from 'redux-loop';
import BrandsSearchBar from './component';
import { reducer, Actions } from './reducer';

const standalone = (element) => {
  const store = createStore(
    reducer,
    undefined,
    compose(
      install(),
      (typeof window !== 'undefined' && window.devToolsExtension) ? window.devToolsExtension() : (x) => x
    )
  );

  const connector = (s) => ({ model: s.toJS() });
  const Container = connect(connector)(BrandsSearchBar);

  render(
    <Container store={store} />,
    element
  );
};

export default {
  reducer,
  View: BrandsSearchBar,
  standalone,
  Actions,
};



/** WEBPACK FOOTER **
 ** ./shared-components/SearchBar/index.js
 **/